var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666687 7.99996C0.666687 3.95026 3.9187 0.666626 7.92941 0.666626C11.9401 0.666626 15.1921 3.95026 15.1921 7.99996C15.1921 12.0497 11.9401 15.3333 7.92941 15.3333C3.9187 15.3333 0.666687 12.0497 0.666687 7.99996ZM10.0873 10.6277L10.5316 10.179C10.5831 10.1269 10.5831 10.0425 10.5316 9.99042L8.56053 7.99984L10.5312 6.00963C10.5828 5.95757 10.5828 5.87316 10.5312 5.82109L10.0869 5.37239C10.0353 5.32031 9.95171 5.32031 9.90014 5.37239L7.92951 7.36256L5.95884 5.37235C5.90727 5.32027 5.82365 5.32027 5.77208 5.37235L5.32778 5.82105C5.27623 5.87312 5.27623 5.95753 5.32778 6.0096L7.29849 7.99984L5.32741 9.99046C5.27586 10.0425 5.27586 10.1269 5.32741 10.179L5.7717 10.6277C5.82327 10.6798 5.9069 10.6798 5.95847 10.6277L7.92951 8.63712L9.90051 10.6277C9.95208 10.6797 10.0357 10.6797 10.0873 10.6277Z",
    fill: "#F86140"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCircle);
export default __webpack_public_path__ + "static/media/iconCloseCircle.39b47b1a7ba210d624276b33d0c81542.svg";
export { ForwardRef as ReactComponent };